import { useContext } from 'react';
import { KioskNavigationContext } from '@/contexts/NavigationContext';
import type { NavigationContextType } from '@/types/navigation';

export const useKioskNavigation = (): NavigationContextType => {
    const context = useContext(KioskNavigationContext);
    if (!context) {
        throw new Error('useKioskNavigation must be used within a NavigationProvider');
    }
    return context;
};
